import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemBrowser.module.css'
import cl2 from '../BaseSimplePage/BaseSimpleItemBrowserHeader.module.css'
import cl3 from './EventDraftsItemBrowser.module.css'
import {Divider, useTheme} from "@mui/material";
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ServerManager from "../../API/ServerManager";
import ItemBrowserHeaderSelect from "../../components/ItemBrowserHeaderSelect";
import EventDraftsItemBrowserSection from "./EventDraftsItemBrowserSection";

const ITEMS_PER_RQ_PAGE = 30;
const TYPING_TIMEOUT = 500; // [ms]

const sectionsConsts = {
    drafts: {
        modeApiName2: "event-drafts",
        listName: "drafts",
        filterExtraParams: {},
        skin: {normalColor: "#eeeedc", selectColor: "#eaecaf"},
    },
    events: {
        modeApiName2: "events",
        listName: "events",
        filterExtraParams: {kultural_goals: "museum"},
        skin: {normalColor: "#e8e8e8", selectColor: "#afecd1"},
    },
}

const EventDraftsItemBrowser = forwardRef(({
                                               sectionsState,
                                               setSectionsState,
                                               onSectionItemSelect,
                                               style,
                                               renderHeaderFunc,
                                               getItemTitleFunc,
                                               getItemSubtitleFunc,
                                               getItemUptitleFunc,
                                               isProcessingFilter, //??
                                               onUpdateItemFunc, //??
                                               searchPlaceholder
                                           }, ref) => {

    const theme = useTheme();

    const [totalText, setTotalText] = useState("");
    const [sortType, setSortType] = useState('id'); // id|name
    const [sortDir, setSortDir] = useState('asc'); // asc|desc

    const [searchText, setSearchText] = useState(''); // строка поиска (поле ввода)

    //----

    const sectionsRqIdCounters = useRef({
        drafts: 0,
        events: 0,
    });
    const [sectionsBrowserState, setSectionsBrowserState] = useState({
        drafts: getBrowserInitialState(),
        events: getBrowserInitialState(),
    })
    const [mainErrorMessage, setMainErrorMessage] = useState("");
    const [lastTypingTime, setLastTypingTime] = useState(0);
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [locationId, setLocationId] = useState(0);


    // for call
    function onFilterEdit(forceUpdate = false) {
        setSectionsBrowserState(prev => ({
            ...prev,
            drafts: { ...prev.drafts, status: "typing" },
            events: { ...prev.events, status: "typing" },
        }));
        setLastTypingTime(forceUpdate ? 0 : Date.now());
        setSectionsState(prev => ({...prev, drafts: {...prev.drafts, filteredItems: []}, events: {...prev.events, filteredItems: []}}));
        //setTotalItemCount(-1);
        setTotalText("");
        sectionsRqIdCounters.current.drafts++;
        sectionsRqIdCounters.current.events++;
    }

    useImperativeHandle(ref, () => {
        return {
            /*async updateItem(itemId, filteredItems, setFilteredItems) {
                const itemData = await ServerManager.getSimpleModeListItem(modeApiName2, itemId);
                const wasIndex = filteredItems.findIndex(x => x.id === itemId);
                if (wasIndex >= 0) {
                    const newFilteredItems = [...filteredItems];
                    newFilteredItems[wasIndex] = itemData;
                    setFilteredItems(newFilteredItems);
                }
                if (onUpdateItemFunc)
                    onUpdateItemFunc();
            },*/
            refreshItems() {
                setRefreshCounter(x => x + 1);
            },
            onFilterEdit(forceUpdate = false) {
                onFilterEdit(forceUpdate);
            }
        };
    }, []);

    // после первого рендера сразу запрашиваем первую порцию
    useEffect(() => {
        requestMainItems();

        // при анмоунте отменяем текущий запрос
        return () => {
            sectionsRqIdCounters.current.drafts++;
            sectionsRqIdCounters.current.events++;
        }
    }, []);

    // for refresh
    useEffect(() => {
        if (refreshCounter > 0)
            requestMainItems();
    }, [refreshCounter]);


    async function requestMainItems() {
        if (locationId === 0) {

            setSectionsBrowserState(prev => ({
                ...prev,
                drafts: { ...prev.drafts, status: "idle" },
                events: { ...prev.events, status: "idle" },
            }));
            return;
        }

        sectionsRqIdCounters.current.drafts++;
        sectionsRqIdCounters.current.events++;
        const rqId = sectionsRqIdCounters.current.events;
        //console.log("rqId", rqId);

        setSectionsBrowserState(prev => ({
            ...prev,
            drafts: { ...prev.drafts, status: "mainLoad" },
            events: { ...prev.events, status: "mainLoad" },
        }));
        try {
            //await new Promise(resolve => setTimeout(resolve, 3500)); // temp!
            const draftsData = await ServerManager.getSimpleModeFilteredList(sectionsConsts.drafts.modeApiName2, ITEMS_PER_RQ_PAGE, searchText, sortType, sortDir, 0, {...sectionsConsts.drafts.filterExtraParams, location_id: locationId});
            const eventsData = await ServerManager.getSimpleModeFilteredList(sectionsConsts.events.modeApiName2, ITEMS_PER_RQ_PAGE, searchText, sortType, sortDir, 0, {...sectionsConsts.events.filterExtraParams, location_id: locationId});
            if (sectionsRqIdCounters.current.events === rqId) {
                setSectionsState(prev => ({
                    ...prev,
                    drafts: {...prev.drafts, filteredItems: draftsData[sectionsConsts.drafts.listName], refsData: draftsData.refs},
                    events: {...prev.events, filteredItems: eventsData[sectionsConsts.events.listName], refsData: eventsData.refs},
                }));
                setTotalText(`В заявках: ${draftsData.total}; В базе: ${eventsData.total}`);
                setSectionsBrowserState(prev => ({
                    ...prev,
                    drafts: { ...prev.drafts, pagination: draftsData.pagination, status: "idle" },
                    events: { ...prev.events, pagination: eventsData.pagination, status: "idle" },
                }));
            }
        } catch (error) {
            if (sectionsRqIdCounters.current.events === rqId) {
                setMainErrorMessage(`Ошибка при загрузке данных: ${error}`);
                setSectionsBrowserState(prev => ({
                    ...prev,
                    drafts: { ...prev.drafts, status: "mainError" },
                    events: { ...prev.events, status: "mainError" },
                }));
            }
        } finally {
            if (sectionsRqIdCounters.current.events !== rqId) {
                //console.log("ignored! rqId", rqId);
            }
        }
    }

    async function requestMoreItems(sectionName) {
        sectionsRqIdCounters.current[sectionName]++;
        const rqId = sectionsRqIdCounters.current[sectionName];
        //console.log("rqId", rqId);

        setSectionsBrowserState(prev => ({
            ...prev,
            [sectionName]: {...prev[sectionName], status: "addLoad"},
        }));
        try {
            //await new Promise(resolve => setTimeout(resolve, 3500)); // temp!
            const data = await ServerManager.getSimpleModeFilteredList(sectionsConsts[sectionName].modeApiName2, ITEMS_PER_RQ_PAGE, searchText, sortType, sortDir, sectionsBrowserState[sectionName].pagination.next_offset, {...sectionsConsts[sectionName].filterExtraParams, location_id: locationId});
            if (sectionsRqIdCounters.current[sectionName] === rqId) {
                setSectionsState(prev => ({
                    ...prev,
                    [sectionName]: {
                        ...prev[sectionName],
                        filteredItems: [...prev[sectionName].filteredItems, ...data[sectionsConsts[sectionName].listName]],
                        refsData: mergeRefDatas(prev[sectionName].refsData, data.refs),
                    },
                }));
                setSectionsBrowserState(prev => ({
                    ...prev,
                    [sectionName]: {...prev[sectionName], pagination: data.pagination, status: "idle"},
                }));
            }
        } catch (error) {
            if (sectionsRqIdCounters.current[sectionName] === rqId) {
                //setMainErrorMessage(`Ошибка при загрузке данных: ${error}`); // TODO popup?
                setSectionsBrowserState(prev => ({
                    ...prev,
                    [sectionName]: {...prev[sectionName], status: "idle"},
                }));
            }
        } finally {
            if (sectionsRqIdCounters.current[sectionName] !== rqId) {
                //console.log("ignored! rqId", rqId);
            }
        }
    }

    // запуск/продление временной задержки во время ввода текста
    useEffect(() => {
        async function wait() {
            const leftTime = lastTypingTime + TYPING_TIMEOUT - Date.now();
            if (leftTime > 0)
                await new Promise(resolve => setTimeout(resolve, leftTime));
            if (!ignore)
                requestMainItems();
        }

        if (sectionsBrowserState.drafts.status !== "typing" && sectionsBrowserState.events.status !== "typing")
            return;

        let ignore = false;
        wait();
        return () => {
            ignore = true;
        }

    }, [sectionsBrowserState, lastTypingTime]);

    return (<div className={cl.main} style={style}>
        <div className={cl2.main}>
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSelect
                    label="Локация"
                    selectedId={locationId}
                    setSelectedId={id => {
                        setLocationId(id);
                        onSectionItemSelect("drafts", 0);
                        onSectionItemSelect("events", 0);
                        onFilterEdit(true);
                    }}
                    apiName2="event-drafts/locations"
                    specialOptions={[{id: 0, name: "(не выбрана)"}]}
                    showIds={true}
                />
            </div>
        </div>
        <Divider component="div"/>
        {locationId === 0 && <p>Выберите локацию</p>}
        {locationId !== 0 && <>
        <BaseSimpleItemBrowserHeader
            totalItemCount={-1}
            customTotalText={totalText}
            sortType={sortType}
            setSortType={setSortType}
            sortDir={sortDir}
            setSortDir={setSortDir}
            searchText={searchText}
            setSearchText={setSearchText}
            theme={theme}
            onFilterEdit={onFilterEdit}
            searchPlaceholder={searchPlaceholder}
        />
        <Divider component="div" className={cl3.sectionDivider}>
            заявки на события
        </Divider>
        <EventDraftsItemBrowserSection
            browserState={sectionsBrowserState.drafts}
            mainErrorMessage={mainErrorMessage}
            state={sectionsState.drafts}
            onItemSelect={id => onSectionItemSelect("drafts", id)}
            getItemTitleFunc={getItemTitleFunc}
            getItemSubtitleFunc={getItemSubtitleFunc}
            getItemUptitleFunc={getItemUptitleFunc}
            sortType={sortType}
            requestMoreItems={() => requestMoreItems("drafts")}
            refreshCounter={refreshCounter}
            skin={sectionsConsts.drafts.skin}
        />
        <Divider component="div" className={cl3.sectionDivider}>
            события в базе
        </Divider>
        <EventDraftsItemBrowserSection
            browserState={sectionsBrowserState.events}
            mainErrorMessage={mainErrorMessage}
            state={sectionsState.events}
            onItemSelect={id => onSectionItemSelect("events", id)}
            getItemTitleFunc={getItemTitleFunc}
            getItemSubtitleFunc={getItemSubtitleFunc}
            getItemUptitleFunc={getItemUptitleFunc}
            sortType={sortType}
            requestMoreItems={() => requestMoreItems("events")}
            refreshCounter={refreshCounter}
            skin={sectionsConsts.events.skin}
        /></>}
    </div>);
});

//------

// tool
function mergeRefDatas(refData1, refData2) {
    if (!refData1)
        return refData2;

    if (!refData2)
        return refData1;

    return deepMerge(refData1, refData2);
}

// tool (from internet)
// TODO! check!
function deepMerge(target, source) {
    // Create a deep copy of the target to avoid mutation of the original object
    const output = {...target};

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key]) && target[key]) {
                // If both are objects, merge recursively
                output[key] = deepMerge(target[key], source[key]);
            } else {
                // Otherwise, use the source value (overwrites target's primitives/arrays)
                output[key] = source[key];
            }
        }
    }

    return output;
}

// tool (from internet)
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function getBrowserInitialState() {
    return {
        status: "", // "", idle, mainLoad, addLoad, mainError, typing
        pagination: {is_last: true},
    };
}

export default EventDraftsItemBrowser;
